var MDB = window.MDB || {};;
MDB.DPN = MDB.DPN || {};
MDB.DPN.Offers = MDB.DPN.Offers || {};

(function ($) {
    var offersContainer = $('#offers-container');
    var searchForm = $('#search-form');
    var hasEditingRights = $('#CanManageOffers').val() === 'True';
    var offers = $('#offers');
    var page2BaseUrl = offers.data('url-view');
    var page3BaseUrl = offers.data('url-edit');
    var crudServiceBaseUrl = document.location.origin + '/api/DPN/Offers';

    $.extend(MDB.DPN.Offers, {
        bootSimpleSearch: function (fnShapeOffersGrid) {
            fnShapeOffersGrid = $.isFunction(fnShapeOffersGrid) ? fnShapeOffersGrid : $.noop;
           
            var offersDataSource = new kendo.data.DataSource({
                transport: {
                    read: {
                        url: function () {
                            // Strip the property prefix as we're only posting a partial model.
                            var queryString = $('#search-form').serialize().replace(/OffersSearchQuery\./g, '');
                            return crudServiceBaseUrl + '/SearchOffers?' + queryString;
                        }
                    }
                },
                pageSize: 20,
                schema: {
                    model: {
                        id: 'Prke',
                        fields: {
                            Prke: { type: 'number' },
                            Description: {},
                            Premium: {},
                            PremiumCode: {},
                            Duration: { type: 'number' },
                            DurationUnit: {},
                            DurationUnitId: {},
                            Price: { type: 'number' },
                            PriceUnit: {},
                            PriceUnitId: {},
                            Discount: { type: 'number' },
                            OfferType: {},
                            OfferTypeId: {},
                            Active: { type: 'boolean' },
                            IsSelected: {type: 'boolean'}
                        }
                    }
                }
            });

            var offersGridConfig = {
                autoBind: !$('#offers-container').hasClass('hidden'),
                dataSource: offersDataSource,
                pageable: true,

                columns: [
                    {
                        field: 'Prke',
                        title: MDB.loadResourceString('OffersSearchResultsViewModel_PRKE_DisplayName')
                    }, {
                        field: 'Description',
                        title: MDB.loadResourceString('OffersSearchResultsViewModel_Description_DisplayName')
                    }, {
                        field: 'Premium',
                        title: MDB.loadResourceString('OffersSearchResultsViewModel_Premium_DisplayName')
                    }, {
                        field: 'PremiumCode',
                        title: MDB.loadResourceString('OffersSearchResultsViewModel_PremiumCode_DisplayName')
                    }, {
                        field: 'Duration',
                        title: MDB.loadResourceString('OffersSearchResultsViewModel_Duration_DisplayName')
                    }, {
                        field: 'DurationUnit',
                        title: MDB.loadResourceString('DPN_Offers_Search_DurationUnit_Header')
                    }, {
                        field: 'Price',
                        title: MDB.loadResourceString('OffersSearchResultsViewModel_Price_DisplayName'),
                        format: '€ {0:n2}'
                    },{
                        field: 'PriceUnit',
                        title: MDB.loadResourceString('DPN_Offers_Search_PriceUnit_Header')
                    }, {
                        field: 'Discount',
                        title: MDB.loadResourceString('OffersSearchResultsViewModel_Discount_DisplayName'),
                        format: '{0:p}'
                    }, {
                        field: 'OfferType',
                        title: MDB.loadResourceString('OffersSearchResultsViewModel_OfferType_DisplayName')
                    }, {
                        field: 'Active',
                        title: MDB.loadResourceString('DPN_Offers_Search_Active_Header'),
                        template: MDB.KendoConfigBuilder.gridBooleanYesNoTemplate('Active')
                    }
                ],
                messages: {
                    commands: MDB.KendoConfigBuilder.commandLabels(),
                    noRecords: MDB.loadResourceString('DataTable_ZeroRecords')
                },
                navigatable: true,
                sortable: { mode: 'multiple' },
                scrollable: false
            };

            var commands = [
                MDB.KendoConfigBuilder.gridCustomLinkCommand(
                    'view',
                    page2BaseUrl,
                    ['Prke', 'Description', 'Premium', 'PremiumCode', 'Duration', 'DurationUnit', 'Price', 'PriceUnit', 'Discount', 'OfferType'],
                    null,
                    'View',
                    'k-i-search'
                )
            ];
            if (hasEditingRights) {
                commands.push(MDB.KendoConfigBuilder.gridCustomLinkCommand('edit-custom', page3BaseUrl, ['id']));
            }

            offersGridConfig.columns.push(MDB.KendoConfigBuilder.gridCommandColumn(commands));

            fnShapeOffersGrid(offersGridConfig);
           
            offers.kendoGrid(offersGridConfig);

            searchForm.on('submit', function (e) {
                e.preventDefault();

                if (searchForm.valid()) {
                    offersContainer.removeClass('hidden');
                    offersDataSource.read();
                    offersDataSource.page(0);
                }
            });
        } 
    });
})(jQuery);